// extracted by mini-css-extract-plugin
export default {"download":"download-wrsIuk","withWallet":"withWallet-pjwTM4","icon":"icon-FDsiEJ","overlay":"overlay-J9y4iF"};